import { useEffect, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

export type PagePropsType = {
  children?: ReactElement;
  title?: string;
};

const Page = (props: PagePropsType): ReactElement => {
  useEffect(() => {
    if (!props.title) return;

    const previousTitle = document.title;
    document.title = props.title;
    return () => {
      document.title = previousTitle;
    };
  }, [props.title]);

  return (
    <>
      {props.children}
      <Outlet />
    </>
  );
};

export default Page;
